(function () {
  if (window.storeLocale !== "en") return;
  if (typeof rivyoTrToEn === "undefined") return;

  var RIVYO_SEL = '[id*="rivyo"],[class*="rivyo"],' +
    '[id*="loyalty"],[class*="loyalty"],' +
    '[id*="wc_review"],[class*="wc_review"],' +
    '[id*="wc-review"],[class*="wc-review"],' +
    '[data-app*="rivyo"],[data-rivyo]';

  function isRivyoCtx(node) {
    var el = node.nodeType === 1 ? node : node.parentElement;
    while (el && el !== document.body) {
      try { if (el.matches && el.matches(RIVYO_SEL)) return true; } catch (e) {}
      var id = (el.id || "").toLowerCase();
      var cls = (typeof el.className === "string" ? el.className : "").toLowerCase();
      if (id.indexOf("rivyo") > -1 || id.indexOf("loyalty") > -1 ||
          id.indexOf("wc_review") > -1 || id.indexOf("wc-review") > -1 ||
          cls.indexOf("rivyo") > -1 || cls.indexOf("loyalty") > -1 ||
          cls.indexOf("wc_review") > -1 || cls.indexOf("wc-review") > -1) {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  function tr(text) {
    var t = text.trim();
    if (!t) return null;
    if (rivyoTrToEn[t]) return text.replace(t, rivyoTrToEn[t]);
    if (typeof rivyoTrToEnPatterns !== "undefined") {
      for (var i = 0; i < rivyoTrToEnPatterns.length; i++) {
        if (rivyoTrToEnPatterns[i].p.test(t)) {
          return text.replace(t, t.replace(rivyoTrToEnPatterns[i].p, rivyoTrToEnPatterns[i].r));
        }
      }
    }
    return null;
  }

  var ATTRS = ["placeholder", "title", "aria-label", "alt",
               "data-message-before", "data-message-after", "data-message-success"];

  function trAttrs(el) {
    for (var i = 0; i < ATTRS.length; i++) {
      var v = el.getAttribute(ATTRS[i]);
      if (v) { var r = tr(v); if (r !== null) el.setAttribute(ATTRS[i], r); }
    }
    if (el.tagName === "INPUT" || el.tagName === "BUTTON" || el.tagName === "SELECT") {
      var val = el.getAttribute("value");
      if (val) { var rv = tr(val); if (rv !== null) el.setAttribute("value", rv); }
    }
  }

  function walkInner(c) {
    if (!c || c.nodeType !== 1) return;
    var w = document.createTreeWalker(c, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = w.nextNode())) {
      var res = tr(n.nodeValue);
      if (res !== null) n.nodeValue = res;
    }
    trAttrs(c);
    var els = c.querySelectorAll("*");
    for (var i = 0; i < els.length; i++) trAttrs(els[i]);
  }

  function walkNode(root) {
    if (!root) return;
    if (root.nodeType === 3) {
      if (isRivyoCtx(root)) {
        var res = tr(root.nodeValue);
        if (res !== null) root.nodeValue = res;
      }
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (isRivyoCtx(root)) { walkInner(root); return; }
    var nested = root.querySelectorAll ? root.querySelectorAll(RIVYO_SEL) : [];
    for (var i = 0; i < nested.length; i++) walkInner(nested[i]);
  }

  function scanAll() {
    var containers = document.querySelectorAll(RIVYO_SEL);
    for (var i = 0; i < containers.length; i++) walkInner(containers[i]);
  }

  var busy = false;

  function init() {
    scanAll();

    var ob = new MutationObserver(function (muts) {
      if (busy) return;
      busy = true;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === "childList") {
          for (var j = 0; j < m.addedNodes.length; j++) walkNode(m.addedNodes[j]);
        } else if (m.type === "characterData" && m.target.nodeType === 3) {
          if (isRivyoCtx(m.target)) {
            var res = tr(m.target.nodeValue);
            if (res !== null) m.target.nodeValue = res;
          }
        }
      }
      busy = false;
    });

    ob.observe(document.body, { childList: true, subtree: true, characterData: true });

    var count = 0;
    var timer = setInterval(function () {
      scanAll();
      if (++count >= 15) clearInterval(timer);
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
